export default __webpack_public_path__ + "static/15-6e4e15104f549aa37d53daf8f00ef156.png";